import { render, staticRenderFns } from "./ProductCommissionPurchasePopupIframe.vue?vue&type=template&id=b7992e32&"
import script from "./ProductCommissionPurchasePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCommissionPurchasePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports